import { useLocation } from 'react-router-dom';
import './DetailsPageBanner.scss'
import Breadcrumb from './components/Breadcrumb';
import { TestSereisRouteURL } from '@Constants/app-route-url.constant';
import SvgIcon from '@Components/icons/SvgIcon';

const DetailsPageBanner = ({ Headings, topicPriority }: any) => {
    const location = useLocation();
    let title = '';
    switch (location.pathname) {
        case TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES:
            title = "Readiness Check"
            break;
        case TestSereisRouteURL.TEST_SERIES:
            title = "Practice Tests"
            break;
        case TestSereisRouteURL.FULL_MOCK_TEST_SERIES:
            title = "Mock Tests"
            break;
        case TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES:
            title = "Previous Year Tests"
            break;
        case `${TestSereisRouteURL.TEST_SERIES}/all`:
            title = "Practice Test";
            break;
        default:
            title = "Practice Test";
            break;
    }

    const testCms = () => {
        switch (location.pathname) {
            case TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES:
                return {
                    title: "Find Your Weak Areas Before It's Too Late.",
                    subtitle: "Identify gaps in concepts, accuracy and time management to improve faster.",
                    heading: "Why Start With Readiness Check?",
                    h1: "Identify Weak Areas",
                    d1: "Know exactly where you lose marks",
                    h2: "Understand Mistakes",
                    d2: "Concept gaps, accuracy & time issues",
                    h3: "Personalized Plan",
                    d3: "Focus only on what matters",
                    h4: "Faster Improvement",
                    d4: "Target effort = better score",
                    footer: "Smart readiness check can improve your score by"


                }
            case TestSereisRouteURL.TEST_SERIES:
                return {
                    title: "Practice Smart. Improve Every Day.",
                    subtitle: "Solve targeted questions, fix mistakes and build accuracy step-by-step.",
                    heading: "Why Practice Matters?",
                    h1: "Improve Accuracy",
                    d1: "Fix mistakes and reduce negative marking",
                    h2: "Build Speed & Confidence",
                    d2: "Solve faster under exam pressure",
                    h3: "Strengthen Weak Areas",
                    d3: "Focus on topics where you lose marks",
                    h4: "Convert Practice into Score",
                    d4: "Every session moves you closer to your target",
                    footer: "Consistent practice can improve your score by"


                }
            case TestSereisRouteURL.FULL_MOCK_TEST_SERIES:
                return {
                    title: "Experience The Real Exam Before The Exam",
                    subtitle: "Take full-length mock tests to build endurance, improve time management and boost your score",
                    heading: "Why Full Length Mock Tests Help?",
                    h1: "Simulate Real Exam Experience",
                    d1: "Get familiar with the actual exam environment and reduce anxiety",
                    h2: "Improve Time Management",
                    d2: "Learn to allocate time to each section effectively",
                    h3: "Identify Strengths & Weaknesses",
                    d3: "Detailed analysis helps you focus on what matters most",
                    h4: "Boost Score & Confidence",
                    d4: "Consistent mocks boosts your score & build confidence",
                    footer: "Consistent mocks can improve your score by"


                }
            case TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES:
                return {
                    title: "Practice Previous Year Papers. Score Higher.",
                    subtitle: "Solve previous year papers to understand the exam pattern, question trends and boost confidence.",
                    heading: "Why Solve Previous Year Papers?",
                    h1: "Understand Exam Pattern",
                    d1: "Get familiar with the type and weightage of questions.",
                    h2: "Identify High Weightage Topics",
                    d2: "Focus on important topics that are asked repeatedly.",
                    h3: "Improve Accuracy",
                    d3: "Practice real exam questions to boost your performance.",
                    h4: "Boost Confidence",
                    d4: "Perform better on exam day with practice and preparation",
                    footer: "Solving previous year papers can improve your score by"

                }
            case `${TestSereisRouteURL.TEST_SERIES}/all`:
                return {
                    title: "Practice Smart. Improve Every Day.",
                    subtitle: "Solve targeted questions, fix mistakes and build accuracy step-by-step.",
                    heading: "Why Practice Matters?",
                    h1: "Improve Accuracy",
                    d1: "Fix mistakes and reduce negative marking",
                    h2: "Build Speed & Confidence",
                    d2: "Solve faster under exam pressure",
                    h3: "Strengthen Weak Areas",
                    d3: "Focus on topics where you lose marks",
                    h4: "Convert Practice into Score",
                    d4: "Every session moves you closer to your target.  Consistent practice can improve your score by 20-40%",
                    footer: "Consistent practice can improve your score by"

                }
            default:
                return {
                    title: "Practice Smart. Improve Every Day.",
                    subtitle: "Solve targeted questions, fix mistakes and build accuracy step-by-step.",
                    heading: "Why Practice Matters?",
                    h1: "Improve Accuracy",
                    d1: "Fix mistakes and reduce negative marking",
                    h2: "Build Speed & Confidence",
                    d2: "Solve faster under exam pressure",
                    h3: "Strengthen Weak Areas",
                    d3: "Focus on topics where you lose marks",
                    h4: "Convert Practice into Score",
                    d4: "Every session moves you closer to your target.  Consistent practice can improve your score by 20-40%",
                    footer: "Consistent practice can improve your score by"
                }
        }
    }


    return (
        <section className="mock-test-listining-container">
            <div className='ia-container'>
                <div className='grid justify-content-between'>
                    <div className='col-12 lg:col-12 py-2'>
                        <div className='pt-4'>
                            <Breadcrumb Headings={topicPriority ? [{ name: "Recommended Test" }] : Headings} />
                        </div>
                        <div className='tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-2 tw-text-white'>
                            <div className='tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-6 lg:tw-pr-4'>
                                {/* <h1 className='tw-text-4xl tw-font-bold tw-mt-3 tw-mb-4' style={{ lineHeight: '1.2 !important' }}>{topicPriority ? "Recommended Tests" : title} For Students Of All Standards</h1> */}
                                <h1 className='tw-text-4xl tw-font-bold tw-mt-3 tw-mb-4' style={{ lineHeight: '1.2 !important' }}>{topicPriority ? "Practice Recommended Test To Improve Faster" : (testCms().title)}</h1>
                                <p>{testCms().subtitle}</p>
                            </div>
                            <div className='tw-col-span-12 lg:tw-col-span-7 xl:tw-col-span-6'>
                                <div className='tw-bg-white tw-text-gray-800 tw-rounded-2xl px-4 tw-py-3 tw-shadow-lg tw-mb-4'>
                                    <h3 className="mb-3 tw-text-lg tw-font-semibold">{topicPriority ? "Why Recommended Test Are Helpful?" : testCms().heading}</h3>
                                    <div className="grid">
                                        <div className="col-12 md:col-6 ia-feature-item">
                                            <div className="flex w-full gap-3">
                                                <div>
                                                    <div className="tw-bg-orange-50 tw-text-orange-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                                                        <SvgIcon name="timeSpeed" size={26} />
                                                    </div>
                                                </div>
                                                <div className="tw-grow">
                                                    <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">{topicPriority ? "Topicwise Recommendations" : testCms().h1}</h3>
                                                    <p className="tw-text-xs">{topicPriority ? "Get recommended test based on the topics you are weak on" : testCms().d1}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 md:col-6 ia-feature-item">
                                            <div className="flex w-full gap-3">
                                                <div>
                                                    <div className="tw-bg-violet-50 tw-text-violet-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                                                        <SvgIcon name="bookCap" size={26} />

                                                    </div>
                                                </div>
                                                <div className="tw-grow">
                                                    <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">{topicPriority ? "Improve Skills" : testCms().h2}</h3>
                                                    <p className="tw-text-xs">{topicPriority ? "Recommended test helps you to improve your skills" : testCms().d2}</p>


                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 md:col-6 ia-feature-item">
                                            <div className="flex w-full gap-3">
                                                <div>
                                                    <div className="tw-bg-indigo-50 tw-text-indigo-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                                                        <SvgIcon name="barChart" size={26} />
                                                    </div>
                                                </div>
                                                <div className="tw-grow">
                                                    <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">{testCms().h3}</h3>
                                                    <p className="tw-text-xs">{testCms().d3}</p>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 md:col-6 ia-feature-item">
                                            <div className="flex w-full gap-3">
                                                <div>
                                                    <div className="tw-bg-green-50 tw-text-green-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                                                        <SvgIcon name="boostConfidence" size={26} />
                                                    </div>
                                                </div>
                                                <div className="tw-grow">
                                                    <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">{topicPriority ? "Boost Score" : testCms().h4}</h3>
                                                    <p className="tw-text-xs">{topicPriority ? "Every recommended test helps you to move closer to your target" : testCms().d4}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='tw-flex tw-justify-center tw-items-center tw-bg-green-100 tw-text-black tw-p-3 tw-mt-2 tw-rounded-lg tw-font-semibold'> <SvgIcon name="downArrow2" className='tw-rotate-180 tw-mr-2' style={{ color: "green" }} size={22} /> <div>{topicPriority?"Practicing recommended test can improve your score by":testCms().footer}<span className='tw-text-green-600 tw-font-bold tw-ml-1'>20-40%</span></div> </div>


                                </div>
                                {/* <img src={require("@Assets/img/inner-banner.png")} alt="" className="twt-w-full twt-h-full tw-object-cover" /> */}

                            </div>
                        </div>

                        {/* <div className="m-t-l-header text-white pt-3 ml-0">
                            <span className="">{topicPriority ? "Recommended Tests" : title} For Students Of All Standards</span>
                        </div>
                        <div className='tw-text-white'>
                            From diagnostics to full-length mock tests, measure every step of your progress to achieve your target score.
                        </div> */}
                    </div>


                </div>

            </div>

        </section>);
};

export default DetailsPageBanner;
